export default {
  SituationCenter: '态势中心',
  FullScreenDisplay: '全屏展示',
  ExitFullScreen: '退出全屏',
  InternetStatisticsOfEndUsers: '终端用户上网统计',
  GatewayDisasterToleranceAnalysis: '网关状态统计',
  ServiceHealthAnalysis24Hours: '近24h服务健康分析',
  AlarmEventMonitoring24H: '告警事件监控',
  BranchTrafficUsageTop5: '近24h分支峰值带宽使用率Top5',
  BandwidthUsageStatistics24H: '近24h出口带宽使用统计',
  UpstreamAndDownlinkBandwidthTrends24H: '近24h上下行带宽趋势图',
  KeyQualityIndicators24H: '近24h关键质量指标',
  EndUsersNumber: '客户端在线数',
  Piece: '件',
  AlarmEvent24Hours: '告警事件数',
  BandwidthUtilization24Hours: '近24h最大带宽使用率',
  GatewayInService: '服务中的网关',
  OpenDeviceGateway: '开启设备级容灾网关',
  OpenLinkGateway: '开启链路级容灾网关',
  AllGatewayServiceExceptionEvents: '网关服务异常事件',
  AllGatewayLinkExceptionEvents: '网关链路中断事件',
  DisasterRecoveryGatewayServiceExceptionEvent: '容灾网关服务异常事件',
  DisasterRecoveryGatewayLinkExceptionEvent: '容灾网关链路中断事件',
  AverageTimeOfEquipmentDisasterRecovery: '设备容灾平均用时（s）',
  AverageTimeOfLinkDisasterRecovery: '链路容灾平均用时（s）',
  Wired: '有线',
  BandWidthAvg: '平均业务带宽',
  MonitorDesc: '监控概述',
  ExcellentTip: '近24h内未发生关键异常事件',
  GoodTip: '近24h内发生关键异常事件且已恢复',
  ErrorTip: '近24h内发生关键异常事件且未恢复',
  HeadBranch: '总部',
  Branch: '分支',
  ServiceExceptionGateway: '服务异常的网关',
  Use: '使用',
  SpeedLimit: '限速',
  UplinkBandwidth: '上行带宽',
  DownstreamBandwidth: '下行带宽',
  Top5branchalarmsinrecent24h: '分支告警数TOP5',
  BandWidthUsedAvg: '平均使用带宽',
  Terminal: '终端',
  UseBandwidth: '使用带宽',
  average: '平均',
  PeakBandwidthUtilizationRateOfUplinkDownlinkLast24h: '近24h上/下行峰值带宽使用率',
  AppBandwidthUsageStatistics24H: '近24h TOP5应用带宽趋势图',
  AppPeakBandwidthUtilizationRateOfUplinkDownlinkLast24h: '近24h应用峰值带宽统计（top5）',
  MultiBranch: '同区域多分支',
  SomeBranchServiceExceptions: '部分分支服务异常',
  SingleBranch: '单分支',
  AppBandwidthUpUsageStatistics24H: '近24h TOP5应用上行带宽趋势图',
  AppBandwidthDownUsageStatistics24H: '近24h TOP5应用下行带宽趋势图',
  BandwidthUpUsageStatistics24H: '近24h上行带宽趋势图',
  BandwidthDownUsageStatistics24H: '近24h下行带宽趋势图',
  NetworkQuality24H: '近24h网络质量',
  NetworkQualityStatistics24H: '近24h网络质量趋势图',
  Unit: '单位',
  DedicatedlinkBandwidthTrends24H: '近24h专线带宽趋势图',
  Uplink: '上行',
  Downlink: '下行',
  Setting:'设置',
  AutomaticMapSwitching: '地图自动切换',
  GlobalMapModel: '全球地图模型',
  Open: '开',
  Close: '关',
  RefreshFrequency: '数据更新频率',
  AlarmStatusDisplay: '告警状态展示',
  AlarmEventsDisplay: '告警事件展示',
  OnlyUnrecovered: '告警中',
  AlarmSettingTips: '设备状态变动告警（上线/下线）只有“已告警”状态，若您选择仅展示告警中状态，将不展示这类型事件。',
}